<template>
  <v-row>
    <v-col class="mb-0 mt-0 pb-0 pt-0" cols="3" v-if="envSelectionEnabled">
      <v-select :items="envsList" v-model="selectedEnv" label="Environment" />
    </v-col>
    <v-col class="mb-0 mt-0 pb-0 pt-0" :cols="envSelectionEnabled ? 9 : 12">
      <v-autocomplete
        v-model="selectedBusiness"
        :items="businesses"
        :rules="businessRules"
        :loading="isLoading"
        :search-input.sync="searchBusinessName"
        :item-text="getItemDisplayName"
        chips
        small-chips
        clearable
        hide-no-data
        hide-selected
        item-value="id"
        label="Select practice*"
        placeholder="Start typing to Search"
        return-object
      >
        <template v-slot:append-item>
          <div v-intersect="handleAutocompleteIntersection" />
        </template>
      </v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>
import _ from 'lodash';
import CONFIG from '@/config';
import { EnvsNamesMap } from '@/constants';
import { businessApiV1 } from '@/api/v1';
import { businessApiV2 } from '@/api/v2';

const BUSINESSES_FETCH_LIMIT = 20;

export default {
  props: {
    envSelectionEnabled: {
      type: Boolean,
      default: false
    },
    business: Object
  },
  data() {
    return {
      searchBusinessName: '',
      isBusinessesLoading: false,
      selectedBusiness: this.business,
      businessRules: [(v) => !!v || 'Practice is required'],
      businesses: this.business ? [this.business] : [],
      isLoading: false,
      envsList: Object.values(EnvsNamesMap),
      selectedEnv: CONFIG.ENV,
      businessesTotalCount: 0
    };
  },
  watch: {
    searchBusinessName: _.debounce(function (newVal = '', prevVal = '') {
      if (!newVal) {
        return;
      }

      if (newVal !== prevVal) {
        this.isLoading = true;
        this.businesses = [];
        this.businessesTotalCount = 0;

        return this.fetchBusinesses();
      }
    }, 1000),
    selectedBusiness() {
      this.onBusinessChanged();
    },
    selectedEnv() {
      this.businesses = [];
      this.$emit('onEnvChanged', this.selectedEnv);
    }
  },
  methods: {
    async fetchBusinesses() {
      const { items, totalCount } = await (
        this.$store.getters.isMatcherApiV2Enabled
          ? businessApiV2
          : businessApiV1
      ).fetchBusinesses({
        search: this.searchBusinessName,
        from: this.businesses.length === 0 ? 0 : this.businesses.length - 1,
        to: this.businesses.length - 1 + BUSINESSES_FETCH_LIMIT,
        environment: this.selectedEnv
      });

      this.businesses = [...this.businesses, ...items];
      this.businessesTotalCount = totalCount;
      this.isLoading = false;
    },
    onBusinessChanged() {
      this.$emit('onBusinessChanged', this.selectedBusiness);
    },
    async handleAutocompleteIntersection(entries, observer, isIntersecting) {
      if (
        isIntersecting &&
        this.businesses.length < this.businessesTotalCount &&
        !this.isLoading
      ) {
        await this.fetchBusinesses();
      }
    },
    getItemDisplayName(item) {
      return `${item.name} (${item.id})`;
    }
  }
};
</script>
